// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import { DatePicker } from 'material-ui-pickers';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

import * as uniqid from "uniqid";

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import { FormControlLabel } from '@material-ui/core';

// Register the plugin
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageCrop, FilePondPluginImageResize, FilePondPluginImageTransform);

interface State {
  date: string;
  description: any;
  password: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  isFinished: boolean;
  isPublic: boolean;
  isUpdating: boolean;
  filesOnServer: any;
  title: any;
  toLocation: any;
  toDate: Date | null;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class GalleryProfile extends React.Component<Props, State> {

  private pond: any;

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      date: this.formatDate(new Date()),
      description: "",
      employee: "",
      errors: [],
      files: [],
      filesOnServer: [],
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isPublic: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      password: "",
      product: "",
      products: [],
      title: "",
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  async componentWillMount() {
    if (this.state.isUpdating) {
      await NetworkManager.request(`gallery/details/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
        this.setState({
          date: result.info.date,
          filesOnServer: Object.values(result.pictures),
          password: result.info.password,
          isPublic: result.info.password == "",
          title: result.info.title
        });
      });
    } else {
      this.setState({
        password: uniqid.process()
      });
    }
  }

  formatDate = (date: any) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1).toString();
    let day = '' + d.getDate().toString();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  padLeft(originalString: string, length: number, character: string): string {
    const numberChars: number = length - originalString.length;
    let completedString = originalString;

    //Iterate to add the number of specific character
    for (let i = 0; i < numberChars; i++) {
      completedString = character + completedString;
    }

    return completedString;
  }

  handleChange = (name = "") => {
    return (event: React.ChangeEvent<any>) => {
      const key = name != "" ? name : event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.title == "") {
        errors['title'] = "Ajouter un titre";
      }
      if (this.state.date == "") {
        errors['date'] = "Ajouter une date";
      }
      if (this.state.password == "") {
        errors['password'] = "Ajouter mot de passe";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} de l'emprunt en cours...`);
        const formattedDate = this.formatDate(this.state.date);
        console.log(formattedDate);
        try {
          await NetworkManager.request(
            `gallery${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
            date: formattedDate,
            password: this.state.isPublic ? "" : this.state.password,
            title: this.state.title
          }).then((response) => {
            MainStore.showNotification(response.text);
            MainStore.goBack(this.props.history.location.pathname);
            this.props.history.goBack();
          });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  handleMainImageChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        files: file,
        image: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  deletePicture = (item: any) => {
    return async (event: React.MouseEvent<any>) => {
      NetworkManager.request(`gallery/upload/${this.props.match.params.id}`, MethodRequest_e.DELETE, {
        filename: item
      });
      const array = [...this.state.filesOnServer]; // make a separate copy of the array
      const index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({ filesOnServer: array });
      }
    };
  }

  handleChangeDamagedMaterial = () => {
    let pwd = this.state.password;

    if(this.state.isUpdating && pwd == "") {
      pwd = uniqid.process();
    }
    this.setState((prevState: State) => ({
      isPublic: !prevState.isPublic,
      password: pwd
    }));
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const id = this.props.match.params.id;
    const _this = this;
    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'une galerie</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <TextField
              label="Titre"
              name="title"
              value={this.state.title}
              error={Boolean(this.state.errors['title'])}
              helperText={this.state.errors['title']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          {!_this.state.isPublic && <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <TextField
              label="Mot de passe"
              name="password"
              value={this.state.password}
              error={Boolean(this.state.errors['password'])}
              helperText={this.state.errors['password']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>}
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <DatePicker
              label="Date"
              name="date"
              format="DD.MM.YYYY"
              value={this.state.date}
              error={Boolean(this.state.errors['date'])}
              helperText={this.state.errors['date']}
              fullWidth={true}
              onChange={(date) => { this.setState({ date: date }); }} />
          </Grid>
          <Grid item={true} xs={12} className="form-field">
            <FilePond
              ref={(ref: any) => (this.pond = ref)}
              files={this.state.files}
              allowMultiple={true}
              imageResizeTargetHeight={1440}
              imageTransformOutputMimeType={'image/jpeg'}
              imageTransformOutputQuality={85}
              imageResizeUpscale={false}
              onprocessfile={(error: any, file: any) => {
                this.setState((prevState: State) => ({
                  filesOnServer: [...prevState.filesOnServer, `${file.serverId}.jpg`]
                }));
                this.pond.removeFile(file.id);
              }}
              onupdatefiles={(fileItems: any) => {
                // Set currently active file objects to this.state
                this.setState({
                  files: fileItems.map((fileItem: any) => fileItem.file)
                });
              }}
              server={`${NetworkManager.getApiServer()}/gallery/upload/${this.props.match.params.id}`}
            />
          </Grid>
          <Grid item={true} xs={12}>
            <FormControlLabel
              control={<Switch color="primary" value="damagedMaterial" />}
              onChange={this.handleChangeDamagedMaterial}
              label="Galerie publique"
              checked={_this.state.isPublic} />
          </Grid>
        </Grid>
        <Grid container={true} spacing={16} className="form-container">
          {this.state.filesOnServer.map(function (item: any, i: any) {
            console.log('test');
            const src = `${NetworkManager.getApiServer()}/img/gallery/${id}/thumbnail/${item}`;
            return (
              <Grid item={true} xs={6} md={4} lg={2} xl={2} key={i} className="form-field">
                <img src={src} alt={`Image ${i}`} />
                <Button variant="raised" color="secondary" className=" square"
                  onClick={_this.deletePicture(item)}>
                  Supprimer
                </Button>
              </Grid>
            );
          })}
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/GalleryProfile.tsx